import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { IApiBaseProps, IResultResponse } from '@common/api.models';
import { envConfigs } from '@config/envConfigs';
import { createGetOptionsCustomPropsFn, createGetOptionsCustomPropsWithSearchFn } from '@common/selectOptions.services';
import { apiServerDelete, apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import {
  ICreateProjectTeamRequest,
  IProjectTeam,
  IProjectTeamOption,
  ITeamsOptionsByCompanyCodeRequest,
  ITeamsOptionsByCompanyIdRequest,
  ITeamsOptionsByCompanyTypeIdOrganizationTypeIdRequest,
  IUpdateProjectTeamRequest,
} from './projectTeam.models';

export const apiRoutes = {
  getProjectTeamsWithUser: '/Teams/WithUsers',
  createProjectTeam: '/Teams',
  updateProjectTeam: '/Teams',
  deleteProjectTeam: '/Teams',
  getTeamOptionsByCompanyTypeIdOrganizationTypeId: '/Teams/Options/ByCompanyTypeIdOrganizationTypeId',
  getTeamOptionsByCompanyId: '/Teams/Options/ByCompanyId',
  getTeamOptionsByCompanyCode: '/Teams/Options/ByCompanyCode',
  searchTeamDistributionOption: '/Teams/Distributions/Options/Search',
};

export interface IGetProjectTeamsWithUserProps extends IApiBaseProps {
  companyId: number;
}

export const getProjectTeamsWithUserAsync = async (
  props: IGetProjectTeamsWithUserProps,
): Promise<IPagedResultsV1<IProjectTeam>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectTeam>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectTeamsWithUser}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export const createProjectTeamAsync = async (
  request: ICreateProjectTeamRequest,
): Promise<IItemResponse<IProjectTeam>> => {
  const result = await apiServerPost<IItemResponse<IProjectTeam>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.createProjectTeam}`,
    request,
  );
  return result.data;
};

export const updateProjectTeamAsync = async (
  request: IUpdateProjectTeamRequest,
): Promise<IItemResponse<IProjectTeam>> => {
  const result = await apiServerPut<IItemResponse<IProjectTeam>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateProjectTeam}/${request.id}`,
    request,
  );
  return result.data;
};

export interface IDeleteProjectTeamProps extends IApiBaseProps {
  id: number;
}

export const deleteProjectTeamAsync = async ({ id, ...props }: IDeleteProjectTeamProps): Promise<IResultResponse> => {
  const result = await apiServerDelete<IResultResponse>(
    `${envConfigs.apiBaseUrl}${apiRoutes.deleteProjectTeam}/${id}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export const getTeamOptionsByCompanyIdAsync = createGetOptionsCustomPropsFn<
  IProjectTeamOption,
  ITeamsOptionsByCompanyIdRequest
>(apiRoutes.getTeamOptionsByCompanyId);

export const getTeamOptionsByCompanyCodeAsync = createGetOptionsCustomPropsFn<
  IProjectTeamOption,
  ITeamsOptionsByCompanyCodeRequest
>(apiRoutes.getTeamOptionsByCompanyCode);

export const getTeamOptionsByCompanyTypeIdOrganizationTypeIdAsync = createGetOptionsCustomPropsFn<
  IProjectTeamOption,
  ITeamsOptionsByCompanyTypeIdOrganizationTypeIdRequest
>(apiRoutes.getTeamOptionsByCompanyTypeIdOrganizationTypeId);

export interface IGetTeamDistributionOptionsWithSearchProps extends IApiBaseProps {
  masterScheduleId: number;
  projectCompanyId: number;
  keyword: string;
}
export const getTeamDistributionOptionsWithSearchAsync = createGetOptionsCustomPropsWithSearchFn<
  IProjectTeamOption,
  IGetTeamDistributionOptionsWithSearchProps
>(apiRoutes.searchTeamDistributionOption);
